// @flow
import type {Story} from './entities'

console.log('v1.0.5')

let updateListeners:((story:Story)=>void)[] = []
let writeMiddlewares:((story:Story)=>Story)[] = []
let cf = null

if(process.env.NODE_ENV !== 'production'){
  let value:Story | null = require('./initialStory.json')
  let l = []
  window.contentfulExtension = {
    init: cb => setTimeout(cb({
      window: {
        updateHeight: () => null
      },
      entry: {
        fields: {
          'id-de-DE': { locales: ['de-DE', 'de-AT'] },
          'id-de-AT': { locales: ['de-DE', 'de-AT'] }
        }
      },
      field: {
        id: 'id-de-DE',
        getValue: () => value,
        locale: 'de-DE',
        setValue: (val:Story) => {
          value = val
          setTimeout(() => l.forEach(l => l(val)), 100)
        },
        onValueChanged: (cb:*) => {l.push(cb)}
      }
    }), 100)
  }
}

window.contentfulExtension.init(_cf => {
  cf = _cf
  cf.window.updateHeight(900)
  cf.field.onValueChanged(story => {
    updateListeners.forEach(l => l(story || emptyStory))
  })
})



export function update(story:Story){
  story = writeMiddlewares.reduce((story,fn)=>fn(story),story)
  if(!cf) return
  if(story.COMPONENTS.length) cf.field.setValue(story)
  else cf.field.removeValue()
}

export function getStory():Story{
  let result = cf ? cf.field.getValue() || emptyStory : emptyStory
  // old story does not have content or components set
  Object.keys(result.GRID).forEach(key => {
    if(!result.GRID[key].content)
    result.GRID[key] = {
      content: '',
      components: [],
      ...result.GRID[key]
    }
  })
  return result
}

window.getStory = getStory

export function addWriteMiddleware(cb:(story:Story)=>Story){
  writeMiddlewares.push(cb)
}

export function addChangeListener(cb:(story:Story)=>void){
  updateListeners.push(cb)
  if(cf) cb(getStory())
  return cb
}

export function removeCangeListener(cb:(story:Story)=>void){
  updateListeners = updateListeners.filter(l => l !== cb)
}

export function getLocale():string{
  if(!cf) return ''
  return cf.field.locale
}

export function getLocales():string[]{
  if(!cf) return []
  const ownLocale = getLocale()
  const name = cf.field.id
  return cf.entry.fields[name].locales.filter(l => l !== ownLocale)
}

export function cloneLocale(locale:string){
  if(process.env.NODE_ENV !== 'production'){
    return console.log('clone Content', locale)
  }
  if(!cf) return
  const name = cf.field.id
  const newContent = cf.entry.fields[name]._fieldLocales[locale]._value
  update(newContent)
}

export function getComponentFromLocale(locale:string, gridArea:string) {
  if(process.env.NODE_ENV !== 'production'){
    console.log('clone component', locale, gridArea)
    return null
  }
  if(!cf) return null
  const name = cf.field.id
  const targetContent = cf.entry.fields[name]._fieldLocales[locale]._value
  if(!targetContent) return null
  const targetComponent = targetContent.COMPONENTS.find(c => c.props.gridArea === gridArea) 
  return targetComponent || null
}

export function getGridAreasByLocale(locale:string){
  if(process.env.NODE_ENV !== 'production'){
    return ['grid-a', 'grid-b', 'grid-c']
  }
  if(!cf) return []
  const name = cf.field.id
  const story = cf.entry.fields[name]._fieldLocales[locale]._value
  if(!story || !story.COMPONENTS) return []
  return story.COMPONENTS.map(c => c.props.gridArea)
}

const emptyStory:Story = {
    COMPONENTS: [],
    GRID: {
        MOBILE_M:  {active: true, content: '', components: []},
        MOBILE_L:  {active: false, content: '', components: []},
        TABLET:    {active: false, content: '', components: []},
        LAPTOP:    {active: false, content: '', components: []},
        LAPTOP_L:  {active: false, content: '', components: []},
        LAPTOP_XL: {active: false, content: '', components: []}
    },
    GRID_GAP: {
        MOBILE_M:  10,
        MOBILE_L:  15,
        TABLET:    15,
        LAPTOP:    16,
        LAPTOP_L:  23,
        LAPTOP_XL: 29
    },
    STORY_URLS: {},
    CONFIG: {}
}


// WEBPACK FOOTER //
// ./src/cf.js